<template>
    <div>
        <div>

            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <v-card flat>

                    <v-card-title>
                        {{title}}
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            :label=$page.language.user_list.search
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>

                    <smart-table
                        endpoint="users.list"
                        scroll-region
                        id="users_table"
                        :headers="headers"
                        :items-per-page="8"
                        :search="search"
                        :loading="loading"
                        class="flat"
                        :multi-sort="true"
                        :footer-props="{showFirstLastPage: true}"
                        @click:row="rowClick"
                    >
                        <template v-slot:item.canCloakAs="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-show="item.canCloakAs"
                                        @click.stop.prevent="cloakAsUser(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        mdi-account-switch
                                    </v-icon>
                                </template>
                                <span>Cloak as {{ item.name }}</span>
                            </v-tooltip>
                        </template>
                        <template #item.computed_column="{ item }">{{ item.name_first }} {{ item.name_last }}</template>
                    </smart-table>
                </v-card>
            </div>
        </div>

    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import SmartTable from "@/Generic/SmartTable";

    export default {
        name: "UsersIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'input': {
                // If this prop is passed-in, its data will be used for the table, and no further data will be fetched
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },

        data() {
            return {
                items: this.input || [],                    // An array of data.  Each element represents one row to be drawn into the data table
                endpoint_uri: '/getusers',          // The URI for retrieving records for the list
                endpoint_method: 'POST',
                title: this.$page.language.user_list.users,
                infiniteScroll: false,
                search: null,
                loading: null,
            }
        },
        computed: {
            enable_cloak: function () {
                return process.env.MIX_ENABLE_CLOAKING;
            },
            headers: function() {
                let headers = [                                  // One header per column to be displayed
                    {
                        text: this.$page.language.user_list.name || 'name',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                        filterable: true,
                        search: null,
                        computed: false,
                    },
                    {
                        text: this.$page.language.user_list.email,
                        align: 'start',
                        sortable: false,
                        value: 'email',
                    },
                    // {
                    //     text: 'Computed',
                    //     align: 'start',
                    //     sortable: false,
                    //     value: 'computed_column',
                    //     computed: true,                  // When this flag is set, it tells the back end not to search the DB for a field with this name
                    // },
                ];
                if(this.enable_cloak === 'true') {
                    headers.push(
                        {
                            text: this.$page.language.user_list.cloak,
                            align: 'start',
                            sortable: false,
                            value: 'canCloakAs',
                            computed: true,
                        }
                    )
                };

                return headers;
            }
        },
        methods: {
            rowClick(item) {
                let url = route('users.show', item.id)
                this.$inertia.visit(url, {
                    method: 'get',
                    data: {},
                    replace: false,
                    preserveState: true,
                    preserveScroll: true,
                    only: [],
                    headers: {},
                    onCancelToken: cancelToken => {},
                    onCancel: () => {},
                    onStart: visit => {},
                    onProgress: progress => {},
                    onSuccess: page => {},
                    onFinish: () => {},
                })
            },
            cloakAsUser(item) {
                this.$inertia.get(route('impersonate', item.id))
            },

        }
    }
</script>
